import { CONTENT_SUB_PATH, CONTRACT_API_PATH } from 'constants/api';
import { ContractTermItemInterface } from 'contract/type';
import { ApiService } from 'service/api/apiService';
import { FetchResult } from 'type/apiType';

interface TermItemInterface {
  id: number;
  type: 'series' | 'season' | 'content';
  title: string;
}

class ContractItemService {
  constructor(private apiService: ApiService<ContractTermItemInterface>) {}

  public async fetchTermItemsByContractId(
    contractId: number,
    termId: number,
    params: Record<string, string>
  ): Promise<FetchResult<ContractTermItemInterface>> {
    const queryParams = new URLSearchParams(params);
    return await this.apiService.fetchBySubPath(
      `${contractId}/terms/${termId}/items/`,
      queryParams
    );
  }

  public async fetchTermItems(
    contractId: number,
    termId: number,
    params?: Record<string, string>
  ): Promise<FetchResult<TermItemInterface>> {
    const queryParams = params ? new URLSearchParams(params) : new URLSearchParams();
    const url = `${contractId}/terms/${termId}/items/`;
    return await this.apiService.fetchBySubPath(url, queryParams);
  }

  public async createItemsForParent(parentId: number, ids: number[]): Promise<void> {
    return await this.apiService.createItemsForParent(
      parentId,
      CONTENT_SUB_PATH,
      { ids },
      undefined
    );
  }
  public async createItemsForContractTerm(
    contractId: number,
    termId: number,
    type: string,
    ids: number[]
  ): Promise<void> {
    const body = { type, ids };
    await this.apiService.createByUrl(`${contractId}/terms/${termId}/items/`, body);
  }

  public async deleteItemsForContractTerm(
    contractId: number,
    termId: number,
    type: string,
    ids: number[]
  ): Promise<void> {
    const body = { type, ids };
    const url = `${contractId}/terms/${termId}/items/`;
    await this.apiService.deleteByUrl(url, body);
  }

  public async deleteItemsForParent(parentId: number, ids: number[]): Promise<void> {
    const queryParams = new URLSearchParams();
    ids.forEach(id => queryParams.append('ids', id.toString()));
    return await this.apiService.deleteItemsForParent(parentId, CONTENT_SUB_PATH, queryParams);
  }
}

export const contractContentService = new ContractItemService(new ApiService(CONTRACT_API_PATH));
